<template>
    <div class="ukey" style="height: 100%;">
        <div id="ukey_plugs">

        </div>
        <div v-show="false">
            <table border="0" cellpadding="0" cellspacing="0">
                <td height="30">
                    <h3>
                        获取选定证书的信息</h3>
                </td>
                <div style="display: none;">
                    <tr>
                        <td height="30">
                            证书主题DN：
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="text" id="SubjectDNFilter" style="width: 650px">
                        </td>
                    </tr>
                    <tr>
                        <td height="30">
                            颁发者主题DN：
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="text" id="IssuerDNFilter" style="width: 650px">
                        </td>
                    </tr>
                    <tr>
                        <td height="30">
                            证书序列号：
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="text" id="SerialNumFilter" style="width: 650px">
                        </td>
                    </tr>
                    <tr>
                        <td height="30">
                            CSP名称(多家CSP用"||"分隔)：
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="text" id="CSPNameFilter" style="width: 650px">
                        </td>
                    </tr>
                </div>
                <tr>
                    <td height="50">
                        <a href="http://xiangjunkeji.cn/CM-API/ukey/client/CryptoKit.SCXJKJ.exe">
                            <input type="button" value="下载ukey插件 [一台电脑安装一次即可]">
                        </a>
                    </td>
                </tr>
                <tr>
                <tr height="30">
                    注意 ： 不安装ukey驱动无法签名
                </tr>
                <tr>

                    <td height="30">
                        <input type="button" name="SelectCertificateButton" value="Select certificate [选择证书]"
                               @click="SelectCertificateOnClick()">

                    </td>
                </tr>
                <tr>
                    <td height="30">
                        选择证书结果(返回值)：
                    </td>
                </tr>
                <tr>
                    <td>
                        <input type="text" id="SelectCertResult" style="width: 650px">
                    </td>
                </tr>
                <tr>
                    <td height="30">
                        <input type="radio" name="InfoTypeID" value="SubjectDN" checked="checked"/>SubjectDN
                    </td>
                </tr>
                <tr>
                    <td height="30">
                        <input type="button" name="GetCertInfoButton" value="Get Cert Information [获取证书信息]"
                               @click="GetCertInfoOnClick()">
                    </td>
                </tr>
                <tr>
                    <td height="30">
                        证书信息(返回值)：
                    </td>
                </tr>
                <tr>
                    <td>
                        <textarea id="CertInfoContent" rows="8" style="width: 650px"></textarea>
                    </td>
                </tr>
            </table>
            <br/>
            <br/>
            <label>
                <td style="display: none;">
                    哈希算法(仅对RSA算法有效，SM2默认使用SM3哈希算法)：
                </td>
            </label>
            <td style="display: none;">
                <input type="radio" name="p7algorithm"    value="SHA-1"/>SHA-1
                <input type="radio" name="p7algorithm" checked="checked" value="SHA-256"/>SHA-256
                <input type="radio" name="p7algorithm" value="MD5"/>MD5
            </td>
            <td style="display: none;">
                <input type="radio" name="p1algorithm" value="SHA-1"/>SHA-1
                <input type="radio" name="p1algorithm" checked="checked" value="SHA-256"/>SHA-256
            </td>
            <br/>
            <br/>
            <label>
                <h3>
                    PKCS#7分离式哈希签名</h3>
            </label>
            <label>
                Base64编码的签名原文Hash值：
                <br/>
                <input type="text" id="SourceHashData" style="width: 650px" v-model="value"></input>
            </label>
            <br/>
            <br/>
            <label>
                <td>
                    <input type="button" name="SignButton" value="Sign[签名]" @click="SignOnClick()">
                </td>
            </label>
            <br/>
            <br/>
            <label>
                签名结果：
                <br/>
                <textarea id="Signature" rows="8" style="width: 650px"></textarea>
<!--                <embed id="CryptoAgent" type="application/npCryptoKit.Paperless.x86" style="height: 0px; width: 0px">-->
            </label>
            <br/>
            <br/>
            <hr/>
        </div>
    </div>
</template>

<script language="javascript" type="text/javascript">
    // Create ActiveX object according to the platform

    export default {
        props: {
            signatureId: {
                type: String,
            },
        },
        data() {
            return {
                CryptoAgent: '',
                value: this.$route.params.pdfSealHash,
                ukeyId:'',
                browser: -1,     //浏览器类型 0-NPAPI 1-IE
                isDestory: false,
            }
        },
        mounted() {
            this.getData();
//            this.getUkeyVersion();
        },
        beforeDestroy() {
            this.isDestory = true
        },
        methods: {

            getUkeyVersion(){
                let version = this.CryptoAgent.GetVersion();
                this.ukeyId =  this.CryptoAgent.GetKeyID("");
            },

            getData() {
                let plug_div = document.getElementById("ukey_plugs")
                if(plug_div==null||plug_div.offsetParent === null) return

                for(let browser=0;browser<2;browser++){
                    //初始化写印模插件,并且判断出浏览器种类
                    try {
                        let eDiv = document.createElement("div");
                        //if (navigator.appName.indexOf("Internet") >= 0 || navigator.appVersion.indexOf("Trident") >= 0) {
                        if(browser==1){
                            if (window.navigator.cpuClass === "x86" || window.navigator.cpuClass === "win32") {
                                eDiv.innerHTML = "<object id=\"CryptoAgent\" codebase=\"CryptoKit.SCXJKJ.x86.cab\" classid=\"clsid:E9ECFC0E-193C-4386-976D-3384AB7DC58F\" ></object>";
                            } else {
                                eDiv.innerHTML = "<object id=\"CryptoAgent\" codebase=\"CryptoKit.SCXJKJ.x64.cab\" classid=\"clsid:1B717491-3831-42DF-82E9-0BE9BEDFC50D\" ></object>";
                            }
                        } else {
                            eDiv.innerHTML = "<embed id=\"CryptoAgent\" type=\"application/npCryptoKit.SCXJKJ.x86\" style=\"height: 0px; width: 0px\">";
                        }
                        document.getElementById("ukey_plugs").appendChild(eDiv);
                    }
                    catch (e) {
                        this.$message({message: e, type: 'error'});
                        continue
                    }
                    this.CryptoAgent = document.getElementById("CryptoAgent");
                    try{
                        this.CryptoAgent.GetVersion()
                        this.browser = browser
                        break
                    }catch (e) {
                        console.log(e)
                        this.CryptoAgent.remove()
                    }
                }

                if(this.browser==-1){
                    let that = this
                    setTimeout(function () {
                        if(!that.isDestory){
                            that.$message({message: 'Ukey加载失败，请更换360国密版浏览器或低版本浏览器再试', type: 'error'});
                        }
                    }, 1000)
                    return;
                }

                return CryptoAgent
            },





            // Select certificate      需要
            SelectCertificateOnClick() {
                try {
                    document.getElementById("SelectCertResult").value = "";

                    var subjectDNFilter = "";
                    var issuerDNFilter = "";
                    var serialNumFilter = "";
                    var cspNameList = "";
                    var bSelectCertResult = "";
                    subjectDNFilter = document.getElementById("SubjectDNFilter").value;
                    issuerDNFilter = document.getElementById("IssuerDNFilter").value;
                    serialNumFilter = document.getElementById("SerialNumFilter").value;
                    cspNameList = document.getElementById("CSPNameFilter").value;

                    bSelectCertResult = this.CryptoAgent.SelectCertificate(subjectDNFilter, issuerDNFilter, serialNumFilter,
                        cspNameList);
                    // Opera浏览器，NPAPI函数执行结果为false时，不能触发异常，需要自己判断返回值。
                    if (!bSelectCertResult) {
                        var errorDesc = this.CryptoAgent.GetLastErrorDesc();
                        alert(errorDesc);
                        return;
                    }
                    document.getElementById("SelectCertResult").value = bSelectCertResult;
                    return true
                } catch (e) {
                    var errorDesc = this.CryptoAgent.GetLastErrorDesc();
                    // alert(errorDesc);
                    //this.$message.error( errorDesc + '请检查是否插入Ukey');
                    return false
                }
            },

            // Get certificate information   需要
            GetCertInfoOnClick() {
                try {
                    var InfoTypeID = "";
                    var InfoContent = "";

                    document.getElementById("CertInfoContent").value = "";

                    // certificate information identifier
                    InfoTypeID = this.GetSelectedItemValue("InfoTypeID");
                    InfoContent = this.CryptoAgent.GetSignCertInfo(InfoTypeID);
                    // Opera浏览器，NPAPI函数执行结果为false时，不能触发异常，需要自己判断返回值。
                    if (!InfoContent) {
                        var errorDesc = this.CryptoAgent.GetLastErrorDesc();
                        // alert(errorDesc);
                        this.$message.error( errorDesc + '请检查是否插入Ukey');
                        return;
                    }
                    document.getElementById("CertInfoContent").value = InfoContent;
                    return true
                } catch (e) {
                    var errorDesc = this.CryptoAgent.GetLastErrorDesc();
                    // alert(errorDesc);
                    this.$message.error( errorDesc + '请检查是否插入Ukey');
                    return false
                }
            },


            // Sign hash message
            SignOnClick(value, pdfId, id , list) {
                try {
                    var selectedAlg = this.GetSelectedItemValue("p7algorithm");
                    var sourceHashData = value;
                    var signature = "";

                    document.getElementById("Signature").value = "";
                    // sourceHashData = document.getElementById("SourceHashData").value;
                    selectedAlg = "SHA-256"
                    console.log( sourceHashData );
                    console.log( selectedAlg );
                    console.log( this.CryptoAgent );
                    signature = this.CryptoAgent.SignHashMsgPKCS7Detached(sourceHashData, selectedAlg);
                    console.log( signature );
                    // signature = "MIIEvzCCA6egAwIBAgIIMwAABCdmMEYwDQYJKoZIhvcNAQELBQAwWDELMAkGA1UEBhMCQ04xMDAuBgNVBAoMJ0NoaW5hIEZpbmFuY2lhbCBDZXJ0aWZpY2F0aW9uIEF1dGhvcml0eTEXMBUGA1UEAwwOQ0ZDQSBBQ1MgT0NBMzMwHhcNMjIwMzI0MDIwMjQ1WhcNMjMwMzI0MDIwMjQ1WjBqMQswCQYDVQQGEwJDTjEXMBUGA1UECgwOQ0ZDQSBBQ1MgT0NBMzMxDTALBgNVBAsMBFNDWEoxGTAXBgNVBAsMEE9yZ2FuaXphdGlvbmFsLTExGDAWBgNVBAMMDzA1MUDmtYvor5VATjFAMTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAI+qsvqjvq0vTVcywPKGkB8X/CAadUw1MOxkSIb/xnpY4fY3IZuQinV7P22rgTsaw36g0XFFVNL1065/4eqbPcTG41zCAeKc3fGWmFbdcN0JgJtDaporWGK715dPJJreziaUEDMlVQ9y8HmnT48EblVShRk76nOyGAEDVxMEDKEQa2PgmnjpYRaKLHjBpmhMuBmEUwoLDWMyFXeSss+b+88yE7F0Ng4daHtm+M0FZZmO5xS0q9LfN+1pOOXRDxtb1pRp7ZQI8S14IbmA+VPxWkdlYbELoerRyZSnXrxeBrcFI8YzEQFUryuJ6FDbW+x0oWWaLyWknO6QYJwTLyq47JcCAwEAAaOCAXkwggF1MGwGCCsGAQUFBwEBBGAwXjAoBggrBgEFBQcwAYYcaHR0cDovL29jc3AuY2ZjYS5jb20uY24vb2NzcDAyBggrBgEFBQcwAoYmaHR0cDovL2NybC5jZmNhLmNvbS5jbi9vY2EzMy9vY2EzMy5jZXIwHwYDVR0jBBgwFoAUTalX/d9sqS2aRiEOGD+tae7nvugwDAYDVR0TAQH/BAIwADBIBgNVHSAEQTA/MD0GCGCBHIbvKgEEMDEwLwYIKwYBBQUHAgEWI2h0dHA6Ly93d3cuY2ZjYS5jb20uY24vdXMvdXMtMTQuaHRtMD4GA1UdHwQ3MDUwM6AxoC+GLWh0dHA6Ly9jcmwuY2ZjYS5jb20uY24vb2NhMzMvUlNBL2NybDQzNzU0LmNybDAOBgNVHQ8BAf8EBAMCBsAwHQYDVR0OBBYEFJDImMqBhuCnf8R2/UP8g4o2TWPnMB0GA1UdJQQWMBQGCCsGAQUFBwMCBggrBgEFBQcDBDANBgkqhkiG9w0BAQsFAAOCAQEAmTmFv2tGnakRx0UaRk2e+pYodipXy+CuP9AZvY80EexXukGrQjmAIk8zpsqGqN0DI9KPPUBt2EAqAlkShqcaKUAOHO0hqjXZnMbBjcyWbpkS2WgP+xtEIyu5eNEcsFWqNu8K7vjCDur10GR4Uf45BP9Ig37s1acmD2oZkN7n1F2OJ5u6WH/4rRH5LQWQydl9xjC1iIgh064jabJeuJ0J7rXZ2NsDaif1Y7zaC6gxYfes7rNkPX4uzp2VqbpU8xTr46APMME2lhyESd70nbwS9mamqMvY5GqjlQHsQr/t+zxmq4nQjNZ2T7V67FukZ+w289e68t0SlWHoD9K1YZNtxw==";

                    if (!signature) {
                        var errorDesc = this.CryptoAgent.GetLastErrorDesc();
                        console.log( errorDesc );
                        // alert(errorDesc);
                        return;
                    }

                    if(this.ukeyId ==''){
                        this.ukeyId =  this.CryptoAgent.GetKeyID("");
                    }

                    if(this.ukeyId ==''){
                        this.$message.info('请确保ukey插入，刷新页面重试');
                    }

                    document.getElementById("Signature").value = signature;
                    let _this = this;
                    let param = new FormData();
                    param.append('pdfId', pdfId);
                    param.append('id', id);
                    param.append('token', _this.$global.token);
                    param.append('signature', signature);
                    param.append('signatureId', this.signatureId);
                    param.append('list', list);
                    param.append('isUseKey', '1');
                    param.append('udunSerialNumber',  this.ukeyId );
                    _this.$confirm('是否要进行合同签署?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        _this.api.sealPdfContact(param).then(res => {
                            _this.$message.success('ukey签署完成');
                            _this.$router.push('contractSin');
                        })
                    }).catch(() => {

                    });

                } catch (e) {
                    console.log(e);
                    console.log( this.CryptoAgent.GetLastErrorDesc() );
                    var errorDesc = this.CryptoAgent.GetLastErrorDesc();
                    alert(errorDesc);
                }
            },

            GetSelectedItemValue(itemName) {
                var ele = document.getElementsByName(itemName);
                for (let i = 0; i < ele.length; i++) {
                    if (ele[i].checked) {
                        return ele[i].value;
                    }
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .ukey {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ukey/ukey.vue